import React from "react";
import { Drawer, Descriptions, Tag } from "antd";
import { getTagStyle } from "./ChargeConfigsTable"; // reuse your badge style

export default function ChargeViewDrawer({ charge, open, onClose }) {
  if (!charge) return null;

  return (
    <Drawer
      title={
        <span style={{ fontFamily: "Inter", fontSize: 15 }}>
          {`Charge Details: ${charge.code}`}
        </span>
      }
      placement="right"
      size={700}
      onClose={onClose}
      open={open}
      styles={{ body: { paddingBottom: 24 } }}
      zIndex={99999}
    >
      <Descriptions
        column={1}
        bordered
        size="small"
        style={{ fontFamily: "Inter" }}
      >
        <Descriptions.Item label="Code" style={{ fontSize: 13 }}>
          {charge.code}
        </Descriptions.Item>
        <Descriptions.Item label="Name" style={{ fontSize: 13 }}>
          {charge.name}
        </Descriptions.Item>
        <Descriptions.Item label="Category" style={{ fontSize: 13 }}>
          <Tag style={getTagStyle("category", charge.category)}>
            {charge.category}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Charge Target" style={{ fontSize: 13 }}>
          {charge.chargeTarget || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Value" style={{ fontSize: 13 }}>
          {charge.valueType === "PERCENTAGE"
            ? `${(charge.value * 100).toFixed(2)}%`
            : `$${charge.value.toFixed(2)}`}
        </Descriptions.Item>
        <Descriptions.Item label="Value Type" style={{ fontSize: 13 }}>
          {charge.valueType || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Apply On" style={{ fontSize: 13 }}>
          {charge.applyOn || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Currency" style={{ fontSize: 13 }}>
          {charge.currency || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Min Amount" style={{ fontSize: 13 }}>
          {charge.minAmount || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Max Amount" style={{ fontSize: 13 }}>
          {charge.maxAmount || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Display Order" style={{ fontSize: 13 }}>
          {charge.displayOrder || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Status" style={{ fontSize: 13 }}>
          <Tag style={getTagStyle("status", charge.status)}>
            {charge.status}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Effective From" style={{ fontSize: 13 }}>
          {charge.effectiveFrom || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Effective To" style={{ fontSize: 13 }}>
          {charge.effectiveTo || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Country" style={{ fontSize: 13 }}>
          {charge.country}
        </Descriptions.Item>
        <Descriptions.Item label="State" style={{ fontSize: 13 }}>
          {charge.state || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="County" style={{ fontSize: 13 }}>
          {charge.county || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="City" style={{ fontSize: 13 }}>
          {charge.city || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Stage" style={{ fontSize: 13 }}>
          {charge.stage || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Description" style={{ fontSize: 13 }}>
          {charge.description || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Verion No." style={{ fontSize: 13 }}>
          {charge.versionNumber || "-"}
        </Descriptions.Item>
      </Descriptions>
    </Drawer>
  );
}
